import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import { Button, Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import styled from 'styled-components';
import useLogic from './AcLedMappingTeachersModal';

const TeacherDetails = styled(FlexView)`
  border-radius: 4px;
  border: 1px solid ${COLORS.BG_GHOST};
  margin-bottom: 16px;
`;
const CustomButton = styled(FlexView)`
  border-radius: 4px;
  background-color: ${COLORS.GRAY};
  cursor: pointer;
`;
const GreenDot = styled(FlexView)`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: ${COLORS.GRASS};
  margin-left: 8px;
`;

const SlotsInformation = styled(FlexView)``;

const AcLedMappingTeachersModal = ({ teachers, date }) => {
  const { handleBookPAC } = useLogic();

  return (
    <FlexView gutter={24} gap={24}>
      <SlotsInformation>
        <Text variant="h6" size={16}>{`Slots on ${date}`}</Text>
      </SlotsInformation>
      <Separator height={24} />
      {teachers?.map(({ id, name, endTime, startTime, score, isRecommended }) => (
        <TeacherDetails key={id} gutter={24} gap={16}>
          <Row alignItems="center" justifyContent="space-between">
            <Col gutter={0}>
              <Row alignItems="center">
                <Text variant="h6" size={16}>
                  {name}
                </Text>
                {isRecommended && <GreenDot />}
              </Row>
              <Text
                variant="body1Regular"
                size={16}
              >{`Availability: ${startTime} - ${endTime}`}</Text>
              <Text variant="body1Regular" size={16}>{`Score: ${score}`}</Text>
            </Col>
            <Col gutter={0}>
              <CustomButton gutter={16} gap={4} onClick={() => handleBookPAC(id)}>
                <Text variant="cta2" color={COLORS.WHITE}>
                  Book PAC
                </Text>
              </CustomButton>
            </Col>
          </Row>
          <Separator height={24} />
          <Row justifyContent="center">
            <Col gutter={0}>
              <Button
                size="small"
                label="View profile"
                variant="tertiaryWithUnderline"
                onClick={() => window.open(`/users/teachers/${id}`, '_blank')}
              />
            </Col>
            <Col gutter={16}>
              <Button
                size="small"
                label="View class logs"
                variant="tertiaryWithUnderline"
                onClick={() =>
                  window.open(`/users/teachers/${id}?teacher_tab=classrooms`, '_blank')
                }
              />
            </Col>
          </Row>
        </TeacherDetails>
      ))}
    </FlexView>
  );
};

export default AcLedMappingTeachersModal;
